<template>
    <div class="com-codics-hbb-order-admin-banma-body">
        <div class="com-codics-hbb-order-admin-banma-bar-content">
            <div class="com-codics-hbb-order-admin-banma-bar-content-item" v-for="(item, index) in banmaList"
                @click="handleMenuClick(item)" :key="index">
                <el-image class="com-codics-hbb-order-admin-banma-bar-content-item-img" :src="item.img"
                    fit="cover"></el-image>
                <div class="com-codics-hbb-order-admin-banma-bar-content-item-txt" style="top:-30px;">{{ item.title }}
                </div>
                <div class="com-codics-hbb-order-admin-banma-bar-content-item-txt" style="top:30px;">{{ item.detail }}
                </div>
            </div>
        </div>
        <div class="com-codics-hbb-order-admin-shop-bar-content com-codics-hbb-order-admin-shop-bar-content3"
            id="myBiaoZhuShow" style="margin-top: 10px;">
            <img class="com-codics-hbb-order-admin-banma-img" :src="nowBanma.img" ref="myBiaoZhuImg"
                id="myBiaoZhuImg" />
            <div class="com-codics-hbb-order-admin-banma-list">
                <div class="com-codics-hbb-order-admin-banma-list-item" v-for="(item, index) in goodsList" :key="index">
                    <div class="com-codics-hbb-order-admin-banma-list-item-card">
                        <el-image class="com-codics-hbb-order-admin-banma-list-item-card-img" :src="item.img"
                            fit="cover"></el-image>
                        <div class="com-codics-hbb-order-admin-banma-list-item-card-txt">{{ item.title }}</div>
                        <div class="com-codics-hbb-order-admin-banma-list-item-card-btn iconfont">&#xe7b7; 加入购物车</div>
                    </div>
                </div>
            </div>
        </div>
        <el-badge :value="cartData.length" class="com-codics-hbb-order-admin-shop-car-btn">
            <el-button class="iconfont" type="success" round plain @click="shopDrawer = true;">&#xe7b7;
                我的购物车</el-button>
        </el-badge>
    </div>
</template>

<script>
import { listBanma } from '@/api';
import { getImageSize } from '@/utils/myutils';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            banmaList: [
                {
                    title: '水电专场',
                    detail: '日常生活离不开',
                    img: 'https://cdn.bosscaigou.com/huayuan/img/nWXBGxYr4R_1747273187107_4.png',
                    state: 0
                }
            ],
            nowBanma: {
                title: '水电专场',
                detail: '日常生活离不开',
                img: 'https://cdn.bosscaigou.com/huayuan/img/nWXBGxYr4R_1747273187107_4.png',
                state: 0,
                list: [
                    {
                        id: 1,
                        x: 100,
                        y: 100,
                        color: 'red',
                        tag: 'tag1'
                    }
                ]
            },
            goodsList: [
                {

                }
            ],
            cartData: [],
            img: null,
            tagsData: [],
            nowEl: null,
            banMaVisible: false,
            nowId: null,
            banMa: [],           //斑马线的数组
            canBiaoZhu: false,  //是否可以进行标注
            pointColor: '',   //点的颜色
            pointSize: 10,       //点的大小
            tagName: '',
            banMaForm: {},
            qiNiuInfo: {
                token: null
            },
            nowWidth: 0,
            nowHeight: 0
        }
    },
    mounted() {
        this.listBanmaFuc();
        // 防抖函数
        function debounce(func, delay = 100) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        }
        const resizeObserver = new ResizeObserver(debounce(entries => {
            console.log('ResizeObserver:', entries);
            this.nowHeight !== 0 && this.refreshMarker();
        }));
        const targetDiv = document.getElementById('myBiaoZhuShow');
        resizeObserver.observe(targetDiv);
    },
    methods: {
        handleMenuClick(item) {

            jumpTo(this, "标记查询", { id: item.id }, {})

            location.reload();

        },
        async listBanmaFuc() {
            const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
            const res = await listBanma();
            loading.close();
            if (res.code === 200) {
                this.banmaList = res.data;
                const item = this.banmaList.find(item => Math.floor(item.id) == this.$route.params.id);
                this.nowBanma = item == null ? this.banmaList[0] : item;
                getImageSize(this.nowBanma.img, ({ width, height }) => {
                    this.nowWidth = width;
                    this.nowHeight = height;
                    this.refreshMarker();
                });
            } else {

            }
        },
        refreshMarker() {

            var container = document.getElementById('myBiaoZhuShow');

            var childDivs = container.querySelectorAll('.com-hbb-order-marker');

            childDivs.forEach(div => div.remove());

            this.nowBanma.list.forEach(item => {
                this.createMarker(item);
            })

        },
        createMarker(item) {
            var { x, y, id } = item;
            const _this = this;
            var div = document.createElement('div');
            const height = this.$refs.myBiaoZhuImg.offsetHeight;
            const width = this.$refs.myBiaoZhuImg.offsetWidth;
            x = x * (width / this.nowWidth);
            y = y * (height / this.nowHeight);
            div.className = `com-hbb-order-marker marker${id}`;
            y = y + this.$refs.myBiaoZhuImg.offsetTop - this.pointSize / 2;
            x = x + this.$refs.myBiaoZhuImg.offsetLeft - this.pointSize / 2;
            div.style.width = this.pointSize + 'px';
            div.style.height = this.pointSize + 'px';
            div.style.position = 'absolute';
            div.style.backgroundColor = 'rgba(0,0,0,0)';
            div.innerHTML = '<div class="com-hbb-order-marker-inner"></div>';
            div.style.left = x + 'px';
            div.style.top = y + 'px';
            div.setAttribute('data-tag', item.tag);
            div.onclick = function () {
                console.log(this);
                const item = _this.banMa.find(item => item.id === id)
                _this.nowId = item.id;
                _this.nowEl = this;
                _this.banMaVisible = true;
            };
            div.oncontextmenu = ((e) => {
                document.getElementById('myBiaoZhuDiv').removeChild(div)
                console.log(id);  //删除该点的id
                this.banMa = this.banMa.filter(item => item.id !== id)
                if (e && e.preventDefault) {
                    //阻止默认浏览器动作(W3C)
                    e.preventDefault()
                } else {
                    //IE中阻止函数器默认动作的方式
                    window.event.returnValue = false
                }
                return false
            })  //阻止冒泡行为和默认右键菜单事件，删除该点
            document.getElementById('myBiaoZhuShow').appendChild(div)
        },
    }
}
</script>

<style>
#myBiaoZhuShow {
    position: relative;
    /* height: calc(100% - 50px); */
    min-height: 100vh;
    width: 100%;
    float: left;
    box-sizing: border-box;
    overflow-y: auto;
}

#myBiaoZhuShow .marker {
    position: absolute !important;
    border-radius: 50%;
    z-index: 999;
}

#myBiaoZhuShow img {
    border: solid 1px #000;
    display: inline-block;
    z-index: 0;
}

.com-codics-hbb-order-admin-banma-body {
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

.com-codics-hbb-order-admin-banma-bar-content {
    height: 150px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 7.5px;
    transition: .3s;
    overflow-x: scroll;
}

.com-codics-hbb-order-admin-banma-bar-content-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 7.5px;
    cursor: pointer;
}

.com-codics-hbb-order-admin-banma-bar-content-item::before,
.com-codics-hbb-order-admin-banma-bar-content-item::after {
    content: '';
    height: 70px;
    width: 150px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, .5);
    z-index: 11;
}

.com-codics-hbb-order-admin-banma-bar-content-item::before {
    left: -10px !important;
    top: -10px !important;
}

.com-codics-hbb-order-admin-banma-bar-content-item::after {
    right: -10px !important;
    bottom: -10px !important;
}

.com-codics-hbb-order-admin-banma-bar-content-item-img {
    height: 100%;
    width: 210px;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #888;
}

.com-codics-hbb-order-admin-banma-bar-content-item-txt {
    height: 50px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1111;
    font-size: 13px;
    color: #000;
    text-align: center;
    line-height: 50px;
    z-index: 111;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-banma-img {
    height: fit-content;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #888;
}

.com-codics-hbb-order-admin-banma-list {
    height: 100%;
    width: 200px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 5px;
    overflow-y: auto;
}

.com-codics-hbb-order-admin-banma-list-item {
    height: 230px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 10px;
}

.com-codics-hbb-order-admin-banma-list-item-card-img {
    height: 150px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    /* border: 1px solid #888; */
}

.com-codics-hbb-order-admin-banma-list-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    background: #EEE;
}

.com-codics-hbb-order-admin-banma-list-item-card-txt {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 13px;
    color: #000;
    text-align: center;
    line-height: 25px;
    padding: 0 5px;
}

.com-codics-hbb-order-admin-banma-list-item-card-btn {
    height: 25px;
    width: calc(100% - 10px);
    position: relative;
    float: left;
    box-sizing: border-box;
    color: #FF0000;
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    cursor: pointer;
    transition: .3s;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #FF0000;
}

.com-codics-hbb-order-admin-shop-bar-content3 {
    height: fit-content;
}
</style>